import {postRequestWithoutSession} from "./helper-without-session"
export const sendContactUsrequest = (data) => postRequestWithoutSession('contact-us',data,);


 

















// WEBPACK FOOTER //
// ./src/api/ContactUs.js